import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Container from '../UI/Container';
// import ThemeToggle from './ThemeToggle';
import { Logodark, Logolight } from './assets';
import { navData } from './navData';
import './nav.css';
import type { RootState } from '../../Redux/Store';
import { logAnalyticsEvent } from '../../GoogeAnalytics';

export const Nav = () => {
  const dark = useSelector((state: RootState) => state.themeSlice.dark);

  return (
    <Container id="top-navbar">
      <nav
        className="desktop-nav"
        style={{ display: 'flex', alignItems: 'center', maxWidth: '1448px', margin: '0 auto' }}
      >
        <Link
          className="nav-logo-conatiner"
          to="/"
          style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
          onClick={() => {
            logAnalyticsEvent('button_click', {
              button_name: 'nav_logo',
              button_type: 'navigation',
              page_path: window.location.pathname,
            });
          }}
        >
          <img
            src={dark ? Logolight : Logodark}
            alt="VisCommerce"
            className="VC_logo"
            width={243}
            height={60}
          />
        </Link>

        <div className="nav-content">
          <ul className="nav-list">
            {navData.map((item) =>
              item.dropdown ? (
                <li
                  key={item.name}
                  className={`nav-li nav-li-dropdown ${dark ? 'nav-li-color-light' : 'nav-li-color-dark'
                    }`}
                  id={item.id}
                  tabIndex={0}
                >
                  <span className="nav-li-dropdown__label">
                    {item.name}
                    <span
                      className="nav-li-dropdown__caret"
                      aria-hidden="true"
                    >
                      ▾
                    </span>
                  </span>
                  <ul className={`nav-dropdown ${dark ? 'nav-dropdown--dark' : 'nav-dropdown--light'}`}>
                    {item.children.map((child) => (
                      <li
                        key={child.link}
                        className="nav-dropdown__item"
                        style={{ padding: 0 }}
                      >
                        <Link
                          to={child.link}
                          style={{
                            display: 'block',
                            padding: '10px 14px',
                            textDecoration: 'none',
                            color: 'inherit',
                          }}
                          onClick={() => {
                            logAnalyticsEvent('button_click', {
                              button_name: `nav_item_${child.name.toLowerCase().replace(/\s+/g, '_')}`,
                              button_type: 'navigation',
                              page_path: window.location.pathname,
                            });
                          }}
                        >
                          {child.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li
                  key={item.name}
                  className={`nav-li ${dark ? 'nav-li-color-light' : 'nav-li-color-dark'}`}
                  id={item.id}
                >
                  <Link
                    to={item.link}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                    onClick={() => {
                      logAnalyticsEvent('button_click', {
                        button_name: `nav_item_${item.name.toLowerCase().replace(/\s+/g, '_')}`,
                        button_type: 'navigation',
                        page_path: window.location.pathname,
                      });
                    }}
                  >
                    {item.name}
                  </Link>
                </li>
              )
            )}
          </ul>

          <div className="extra-btns">
            <Link
              to="/book-demo"
              id="contact"
              className={`${dark ? 'contact-btn-dark' : 'contact-btn-white'}`}
              style={{ textDecoration: 'none' }}
              onClick={() => {
                logAnalyticsEvent('button_click', {
                  button_name: 'nav_book_demo',
                  button_type: 'cta',
                  page_path: window.location.pathname,
                });
              }}
            >
              Book a 45-min briefing
            </Link>
            {/* <ThemeToggle /> */}
          </div>
        </div>
      </nav>
    </Container>
  );
};
